"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortViews = void 0;
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const isViewMandatory_1 = __importDefault(require("./isViewMandatory"));
function sortViews(views, self) {
    return views
        .map(v => {
        v['strTitle'] = (0, getFromStringOrFunction_1.getFromStringOrFunction)(v.title);
        return v;
    })
        .sort((a, b) => {
        const aIsMandatory = (0, isViewMandatory_1.default)(a, self);
        const bIsMandatory = (0, isViewMandatory_1.default)(b, self);
        const aTitle = a['strTitle'];
        const bTitle = b['strTitle'];
        return aIsMandatory && !bIsMandatory
            ? -1
            : bIsMandatory && !aIsMandatory
                ? 1
                : aIsMandatory && bIsMandatory
                    ? aTitle === null || aTitle === void 0 ? void 0 : aTitle.localeCompare(bTitle)
                    : self.preferences.isFavourite(a.id) && !self.preferences.isFavourite(b.id)
                        ? -1
                        : self.preferences.isFavourite(b.id) && !self.preferences.isFavourite(a.id)
                            ? 1
                            : aTitle === null || aTitle === void 0 ? void 0 : aTitle.localeCompare(bTitle);
    })
        .map(v => {
        // eslint-disable-next-line
        delete v['strTitle'];
        return v;
    });
}
exports.sortViews = sortViews;
exports.default = sortViews;
